<template>
  <span>
    <slot></slot>
    <div class="popover" ref="popper" v-show="isShow" :style="popperStyle">
      <div class="popover-title" v-if="title">{{ title }}</div>
      <div class="popover-content" :style="'background-color: ' + customColor" v-click-outside="hidePopper">
        <slot name="content"><div v-text="content"></div></slot>
      </div>
      <div class="popover-arrow" x-arrow></div>
    </div>
  </span>
</template>
<script>
import Popper from 'popper.js';
import vClickOutside from 'v-click-outside';

export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    trigger: {
      type: String,
      default: 'click',
    },
    width: {
      type: Number,
    },
    max_width: {
      type: Number,
    },
    appendToBody: {
      type: Boolean,
      default: true,
    },
    content: {
      type: String,
      default: '',
    },
    placement: {
      type: String,
      default: 'top',
    },
    forceVisible: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false
    },
    customColor: {
      type: String,
      default: "#fafafa"
    }
  },

  data() {
    return {
      reference: null,
      popper: null,
      isShow: false,
      canHide: false
    };
  },

  computed: {
    popperStyle() {
      if (this.width && this.width !== 276) {
        if (this.width > 0) {
          return { width: `${this.width}px`, maxWidth: `` };
        } else {
          return { width: ``, maxWidth: `${this.max_width}px` };
        }
      }
      return null;
    },
  },

  watch: {
    forceVisible(val) {
      if (val) {
        this.createInstance();
        this.runPopper();
        this.showPopper();
      } else {
        this.hidePopper();
        this.destroy();
      }
    },
    disabled(val) {
      if (!val) {
        this.bindEvent();
      }
    }
  },
  methods: {
    toggle() {
      this.isShow = !this.isShow;
      if (!this.isShow) {
        this.hidePopper();
      }
    },
    // add delay
    hidePopper() {
      if(this.canHide) {
        this.isShow = false;
      }
    },
    showPopper() {
      var t = this;
      t.canHide = false;
      t.isShow = true;
      if (t.timer) clearTimeout(t.timer);
      if (t.popperTimer) clearTimeout(t.popperTimer);

      t.timer = setTimeout(() => {
        t.canHide = true;
      }, 100);
    },

    createInstance() {
      // this.isShow = true;
      this.showPopper();
      if (this.popper) {
        this.popper.update();
        return;
      }
      const placementMapper = {
        top: 'top',
        left: 'left',
        right: 'right',
        bottom: 'bottom',
        topLeft: 'top-end',
        topRight: 'top-start',
        leftTop: 'left-end',
        leftBottom: 'left-start',
        bottomLeft: 'bottom-end',
        bottomRight: 'bottom-start',
        rightTop: 'right-end',
        rightBottom: 'right-start',
      };

      const placement = placementMapper[this.placement] ? placementMapper[this.placement] : 'bottom';

      const reference = this.reference = this.reference || this.$el.children[0];
      const popperEl = this.$refs.popper;
      const options = {
        placement,
      };
      if (this.appendToBody) document.body.appendChild(popperEl);
      this.popper = new Popper(reference, popperEl, options);
    },

    handleClick(e) {
      if (!this.disabled) {
        if (this.$el.contains(e.target)) {
          if (this.isShow) {
            this.hidePopper();
          } else {
            this.createInstance();
          }
        } else if (this.$refs.popper.contains(e.target)) {
          this.showPopper();
        } else {
          if (this.isShow) this.hidePopper();
        }
      } else {
        this.removeEvent();
      }
    },
    bindEvent() {
      if (!this.disabled) {
        const reference = this.reference = this.reference || this.$el.children[0];
        const popper = this.$refs.popper;
        if (!reference || !popper) return;

        if (this.trigger === "none") { 
          // do nothing
        } else if (this.trigger === 'hover') {
          reference.addEventListener('mouseenter', this.createInstance);
          reference.addEventListener('mouseleave', this.hidePopper);
          popper.addEventListener('mouseenter', this.showPopper);
          popper.addEventListener('mouseleave', this.hidePopper);
        } else {
          reference.addEventListener('click', this.handleClick);
          // if (screen.width > 900) {
          // } else {
          //   reference.addEventListener('click', this.handleClick);
          //   reference.addEventListener('touchstart', this.handleClick);
          // }
          // popper.addEventListener('click', this.showPopper);
          // document.documentElement.addEventListener('click', this.handleClick);
        }
      } else {
        this.removeEvent();
      }
    },

    runPopper() {
      this.bindEvent();
    },

    destroy() {
      if (this.popper) {
        this.popper.destroy();
        this.popper = null;
      }
    },

    removeEvent() {
      if (!this.reference) return;
      const popper = this.$refs.popper;
      if (this.trigger === 'focus') {
        this.reference.removeEventListener('focus', this.createInstance);
        this.reference.removeEventListener('blur', this.toggle);
      } else if (this.trigger === 'click') {
        this.reference.removeEventListener('click', this.handleClick);
        this.reference.removeEventListener('touchstart', this.handleClick);
        popper.removeEventListener('click', this.showPopper);
        document.documentElement.removeEventListener('click', this.handleClick);
      } else {
        this.reference.removeEventListener('mouseenter', this.createInstance);
        this.reference.removeEventListener('mouseleave', this.toggle);
      }
    },


  },

  mounted() {
    this.runPopper();
  },

  beforeDestroy() {
    this.removeEvent();
    this.$refs.popper.remove();
    this.destroy();
  },

  
};
</script>

<style lang="scss">
.popover{
  z-index: 1060;
  padding: 1px;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.42857143;
  text-align: left;
  white-space: normal;
  background-color: #fff;
  -webkit-background-clip: padding-box;
  background-clip: padding-box;
  border: 1px solid #ccc;
  border: 1px solid rgba(0,0,0,.1);
  border-radius: 6px;
  -webkit-box-shadow: 0 5px 10px rgba(0,0,0,.2);
  box-shadow: 0 5px 10px rgba(0,0,0,.2);
}
.popover-title {
  padding: 8px 14px;
  margin: 0;
  font-size: 14px;
  background-color: #f7f7f7;
  border-bottom: 1px solid #ebebeb;
  border-radius: 5px 5px 0 0;
}
.popover-content {
  padding: 9px 14px;
}
.popover-arrow, .popover-arrow::after{
  display: block;
  width: 0;
  height: 0;
  border-style: solid;
  border-color: transparent;
  position: absolute;
  /*margin: 10px;*/
}
.popover-arrow{
  border-width: 10px;
  position: absolute;
}
.popover-arrow::after {
  content: "";
  border-width: 9px;
}
.popover[x-placement^="bottom"]{
  margin-top: 15px;
  .popover-arrow {
    border-top-width: 0;
    border-bottom-color: rgba(0,0,0,.25);
    top: -10px;
    left: calc(50% - 5px);
    margin-top: 0;
    margin-bottom: 0;
    &:after{
      top: 1px;
      margin-left: -9px;
      border-top-width: 0;
      border-bottom-color: #fff;
    }
  }
}
.popover[x-placement^="top"]{
  margin-bottom: 15px;
  .popover-arrow {
    border-top-color: #999;
    border-top-color: rgba(0,0,0,.25);
    border-bottom-width: 0;
    bottom: -10px;
    left: calc(50% - 5px);
    margin-top: 0;
    margin-bottom: 0;
    &:after{
      bottom: 1px;
      border-top-color: #fff;
      border-bottom-width: 0;
      margin-left: -9px;
    }
  }
}
.popover[x-placement^="left"]{
  margin-right: 15px;
  .popover-arrow {
    border-right-width: 0;
    border-left-color: #999;
    border-left-color: rgba(0,0,0,.25);
    right: -10px;
    top: calc(50% - 5px);
    &:after{
      right: 1px;
      border-right-width: 0;
      border-left-color: #fff;
      margin-top: -9px;
    }
  }
}
.popover[x-placement^="right"]{
  margin-left: 15px;
  .popover-arrow {
    border-left-width: 0;
    border-right-color: #999;
    border-right-color: rgba(0,0,0,.25);
    left: -10px;
    top: calc(50% - 5px);
    &:after{
      left: 1px;
      border-left-width: 0;
      border-right-color: #fff;
      margin-top: -9px;
    }
  }
}
</style>